import React from "react";

const ArticlesComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default ArticlesComponent;
